import {
  useRouterContext,
  ResourceRouterParams,
  useNavigation,
} from "@pankod/refine-core";
import { Show, Typography, Button, Space, Tag } from "@pankod/refine-antd";

const { Title, Text, Paragraph } = Typography;

export const WholeCaskIssueRequestShow: React.FC = () => {
  return (
    <Show
      title={"Whole Cask issue detail"}
      canEdit={false}
      contentProps={{}}
    >
      Updating ...
    </Show>
  );
};
